// src/utils/gradeUtils.js
import { GRADE_LEVELS } from '../data/gradeLevels';
import { CLASS_STREAMS } from '../data/classStreams';

/**
 * Splits a combined grade string (e.g., "10A") into grade level and stream.
 * Returns { gradeLevel, stream }.
 */
export const splitGrade = (combined) => {
  if (!combined) return { gradeLevel: '', stream: '' };
  // Match digits/letters (e.g., "10", "RR", "R") and optional trailing letter.
  const match = combined.match(/^(\d+|[Rr]+)([A-Za-z]?)$/);
  if (match) {
    const level = match[1];
    const stream = match[2] || '';
    const validStream = CLASS_STREAMS.includes(stream.toUpperCase()) ? stream.toUpperCase() : '';
    return { gradeLevel: level, stream: validStream };
  }
  // Fallback: treat whole string as grade level, no stream.
  return { gradeLevel: combined, stream: '' };
};